import React from 'react'
import { TextField } from '@mui/material'
import { toast } from 'react-toastify'

type AmountStepProps = {
  amountInputInUserCurrency: string
  setAmountInputInUserCurrency: (value: string) => void
  targetAmountInUsd: number
  setTargetAmountInUsd: (value: number) => void
  currency: string
  currencySymbol: string
  convertFromUSD: (usd: number) => number
  formatAmountWithoutCurrency: (value: number) => string
  minAmount?: number
  maxAmount?: number
}

const AmountStep: React.FC<AmountStepProps> = ({
                                                 amountInputInUserCurrency,
                                                 setAmountInputInUserCurrency,
                                                 targetAmountInUsd,
                                                 setTargetAmountInUsd,
                                                 currency,
                                                 currencySymbol,
                                                 convertFromUSD,
                                                 formatAmountWithoutCurrency,
                                                 minAmount,
                                                 maxAmount,
                                               }) => {
  const handleInputChange = (raw: string) => {
    let value = raw.replace(/[^0-9.,]/g, '')

    if (value.includes('.') || value.includes(',')) {
      const separator = value.includes('.') ? '.' : ','
      const parts = value.split(separator)
      parts[1] = parts[1].slice(0, 2)
      value = parts.join(separator)
    }

    setAmountInputInUserCurrency(value)

    const normalized = value.replace(',', '.')
    const parsed = parseFloat(normalized)

    if (!isNaN(parsed)) {
      setTargetAmountInUsd(parsed)
    }
  }

  return (
      <div className="flex flex-col">
        <TextField
            value={amountInputInUserCurrency}
            onChange={e => handleInputChange(e.target.value)}
            type="text"
            size="small"
            placeholder="Withdrawal amount"
            onBlur={() => {
              const parsed = parseFloat(amountInputInUserCurrency.replace(',', '.'))
              if (minAmount && parsed < minAmount) toast.info(`Minimum withdrawal is ${minAmount.toFixed(2)} ${currencySymbol}`)
              if (maxAmount && parsed > maxAmount) toast.info(`Maximum withdrawal is ${maxAmount.toFixed(2)} ${currencySymbol}`)
            }}
            InputProps={{ startAdornment: <div className="text-gray-400 mr-1">{currencySymbol}</div> }}
            inputProps={{ inputMode: 'decimal' }}
            sx={{
              '& input': { MozAppearance: 'textfield' },
              '& input::-webkit-inner-spin-button': { WebkitAppearance: 'none', margin: 0 },
            }}
        />

        <div className="text-xs text-gray-400 mb-4">
          Min: {minAmount === undefined ? '-' : `${currencySymbol}${minAmount.toFixed(2)}`} ·
          Max: {maxAmount === undefined ? '-' : `${currencySymbol}${maxAmount.toFixed(2)}`}
        </div>
      </div>
  )
}

export default AmountStep
